import React, { useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import useStateRef from 'react-usestateref';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { useDispatch } from 'react-redux';

const ProductRestrictionModal = ({ restrictModalDetail, shipGroupDetails, shippingGroupDetailRef, setShippingGroupDetail, handleRestrictModal,
    emailUpdateRef,setEmailUpdate }) => {
    const [removeTypeAction, setRemoveTypeAction, removeTypeActionRef] = useStateRef();
    const [valueEmail, setValueEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [restrictRepeatCall, setRestrictRepeatCall, restrictRepeatCallRef] = useStateRef(false);
    const history = useHistory();
    const dispatch = useDispatch();
    var productRestrictDetails = restrictModalDetail?.restrictionProductsList?.schoolrestriction?.productDetailsList ?
        restrictModalDetail.restrictionProductsList.schoolrestriction.productDetailsList : ''
    var geoRestrictDetails = restrictModalDetail?.restrictionProductsList?.geoRestriction?.productDetailsList ?
        restrictModalDetail.restrictionProductsList.geoRestriction.productDetailsList : ''
    var rtsRestrictDetails = restrictModalDetail?.restrictionProductsList?.specificUsersRestriction?.productDetailsList ?
        restrictModalDetail.restrictionProductsList.specificUsersRestriction.productDetailsList : ''

    function modifyState() {
        let stateObj = { id: "100" };
        window.history.replaceState(stateObj,
            "showCart", "?qr=true");
    }

    const handleGetCartList = (event) => {
        const cartParem = window.location.search
        console.log('cartParem----1', cartParem)
        var actionUrl = `api/rest/cb/cart/cart-details/${cartParem === '?create=true' ? 'true' : 'false'}`;

        fetch(`${window.location.protocol}//${window.location.hostname}/${actionUrl}`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    if (res.isEmptyCart) {
                        // dispatch(updateProfileDetailsAction(true))
                        if (document.getElementById('productRestrictionModalClose')) {
                            document.getElementById('productRestrictionModalClose').click();
                        }
                        history.push('/checkout/cart')
                    } else {
                        modifyState()
                        if (document.getElementById('productRestrictionModalClose')) {
                            document.getElementById('productRestrictionModalClose').click();
                        }
                        shipGroupDetails()
                    }
                    setRestrictRepeatCall(false);
                }
                else {
                    setRestrictRepeatCall(false);
                }
            })
    }

    const handleSubmitVerifyEmail = (event) => {
        event.preventDefault();
        const inputMap = {
            "allowedEmailId": valueEmail
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/product-allowed-user`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    const response = JSON.parse(res?.response)
                    console.log('response--email', response)
                    if (response?.status === 'success') {
                        console.log('response--email--success');
                        if (document.getElementById('productRestrictionModalClose')) {
                            document.getElementById('productRestrictionModalClose').click();
                        }
                        setEmailUpdate(valueEmail)
                        setEmailError('');
                        handleRestrictModal()
                    } else {
                        if (response?.status === 'error') {
                            const errorMessage = response.errorMessage?.[0]?.message;
                            setEmailError(errorMessage);
                            console.log('response--email--errors', errorMessage);
                            console.log('response--email--setEmailError', emailError)
                        }
                    }

                } else {
                    console.log("Error result ---->>>>")
                }
            })
    }

    const handleCheckOutChangeShipping = (event) => {
        if(!restrictRepeatCallRef.current){
            setRestrictRepeatCall(true);
            handleGetCartList()
        }
    }

    async function removeRestrictItem(removeType) {
        if(!restrictRepeatCallRef.current){
            setRestrictRepeatCall(true);
        setRemoveTypeAction(removeType)
        if (removeType === 'removeUsersItem') {
            var commerceIdListSpecial = [];
            var commerceIdListJoinSpecial = "";
            {
                rtsRestrictDetails && rtsRestrictDetails.map((value, key) => {
                    if (value && value.ciId) {
                        commerceIdListSpecial.push(value.ciId)
                    }
                })
            }
            if (commerceIdListSpecial.length > 0) {
                commerceIdListJoinSpecial = commerceIdListSpecial.join(",")
            }
        }

        if (removeType === 'removeGeoItem') {
            var commerceIdListGeo = [];
            var commerceIdListJoinGeo = "";
            {
                geoRestrictDetails && geoRestrictDetails.map((value, key) => {
                    if (value && value.ciId) {
                        commerceIdListGeo.push(value.ciId)
                    }
                })
            }
            if (commerceIdListGeo.length > 0) {
                commerceIdListJoinGeo = commerceIdListGeo.join(",")
            }
        }

        if (removeType === 'removeSchoolItem') {
            var commerceIdListSchool = [];
            var commerceIdListJoinSchool = "";
            {
                productRestrictDetails && productRestrictDetails.map((value, key) => {
                    if (value && value.ciId) {
                        commerceIdListSchool.push(value.ciId)
                    }
                })
            }
            if (commerceIdListSchool.length > 0) {
                commerceIdListJoinSchool = commerceIdListSchool.join(",")
            }
        }

        var actionUrl = "api/rest/cb/cart/delete-quarantine";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            addItemToOrderErrorURL: "/checkout/cart",
            removeItemFromOrderSuccessURL: "/checkout/cart",
            removeItemFromOrderErrorURL: "/checkout/cart",
            setOrderSuccessURL: "/checkout/cart",
            setOrderErrorURL: "/checkout/cart",
            quarantineProceedOrder: "false",
            action: removeTypeActionRef.current,
            removeGeoItems: commerceIdListJoinGeo ? commerceIdListJoinGeo : '',
            removeSchoolItems: commerceIdListJoinSchool ? commerceIdListJoinSchool : '',
            removeUsersItems: commerceIdListJoinSpecial ? commerceIdListJoinSpecial : '',
            quarantineSuccessURL: "/checkout/shipping",
            quarantineErrorURL: "/checkout/shipping"
        }))
        if (res.result == "success") {
            dispatch(updateProfileDetailsAction(true,"cart"))
            handleGetCartList()
        } else {
            setRestrictRepeatCall(false);
            console.log("Error result ---->>>>removeRestrictItem")
        }
    }
    }
    return (
        <div className="modal fade c-modal" id="productRestrictionModalGuest" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                <div className="modal-content">
                    <button type="button" id='productRestrictionModalClose' className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                    <div className="modal-body">
                        <div className="container-fluid state-restrict-modal-body">

                            {rtsRestrictDetails ?
                                <div className="row my-4">
                                    <div className="col-12 mb-3">
                                        <div className="alert alert-danger my-0 d-block" role="alert">
                                            <p className="mb-3" dangerouslySetInnerHTML={{
                                                __html: restrictModalDetail?.restrictionProductsList?.specificUsersRestriction?.quarantineMessage ?
                                                    restrictModalDetail.restrictionProductsList.specificUsersRestriction.quarantineMessage : ''
                                            }}
                                            >
                                            </p>
                                            {restrictModalDetail?.restrictionProductsList?.specificUsersRestriction?.profileEmail ?
                                            <div className="text-center text-md-end">
                                                {/* <input value="Change Shipping Address" className="btn btn-primary me-1" onClick={() => handleCheckOutChangeShipping()} id="changeShippingAddress" /> */}
                                                <button className="btn btn-primary" onClick={() => removeRestrictItem('removeUsersItem')} >Remove Items</button>
                                            </div> :''}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <ul className="list-unstyled remove-restrict-items mb-3">
                                            {rtsRestrictDetails && rtsRestrictDetails.map((productList) => {
                                                return (
                                                    <>
                                                        <li className="remove-restrict-item">
                                                            <div className="row">
                                                                <div className="col-10 col-md-2 list-sku">Item # {productList.catalogRefId}</div>
                                                                <div className="col-10 order-3 order-md-2 col-md-8 list-title">{productList.displayName}</div>
                                                                <div className="col-2 order-2 order-md-3 item-qty text-center fw-normal">Qty: {productList.quantity}</div>
                                                            </div>
                                                        </li>
                                                    </>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                    {restrictModalDetail?.restrictionProductsList?.specificUsersRestriction?.profileEmail ? '' :
                                    <form method="POST" onSubmit={handleSubmitVerifyEmail}>
                                        <div class="row my-4">
                                            <div class={`col-12 ${emailError ? 'd-block' : 'd-none'}`}>
                                                <div id="userAllowedProductError" role="alert" class="alert alert-danger d-block">{emailError}</div>
                                            </div>
                                            <div class="col-8 col-md-4">
                                                <input type="text"
                                                    defaultValue={valueEmail}
                                                    onChange={e => setValueEmail(e.target.value)}
                                                    class="form-control"
                                                    placeholder="Enter valid email" />
                                            </div>
                                            <div class="col-4 col-md-8">
                                                <button type="submit" class="btn btn-primary block">Verify</button>
                                            </div>
                                        </div>
                                    </form>
                                    }
                                </div>
                                : ''}

                            {geoRestrictDetails ?
                                <div className="row my-4">
                                    <div className="col-12 mb-3">
                                        <div className="alert alert-danger my-0 d-block" role="alert">
                                            <p className="mb-3" dangerouslySetInnerHTML={{
                                                __html: restrictModalDetail?.restrictionProductsList?.geoRestriction?.quarantineMessage ?
                                                    restrictModalDetail.restrictionProductsList.geoRestriction.quarantineMessage : ''
                                            }}
                                            >
                                            </p>
                                            <div className="text-center text-md-end geo-restrict-product">
                                                <button className="btn btn-primary geo-restrict-change" onClick={() => handleCheckOutChangeShipping()} id="changeShippingAddress" >Change Shipping Address</button>&nbsp;
                                                <button className="btn btn-primary geo-restrict-change-remove" onClick={() => removeRestrictItem('removeGeoItem')} >Remove Items</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <ul className="list-unstyled remove-restrict-items mb-3">
                                            {geoRestrictDetails && geoRestrictDetails.map((productList) => {
                                                return (
                                                    <>
                                                        <li className="remove-restrict-item">
                                                            <div className="row">
                                                                <div className="col-10 col-md-2 list-sku">Item # {productList.catalogRefId}</div>
                                                                <div className="col-10 order-3 order-md-2 col-md-8 list-title">{productList.displayName}</div>
                                                                <div className="col-2 order-2 order-md-3 item-qty text-center fw-normal">Qty: {productList.quantity}</div>
                                                            </div>
                                                        </li>
                                                    </>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                : ''}
                            {productRestrictDetails ?
                                <div className="row my-4">
                                    <div className="col-12 mb-3">
                                        <div className="alert alert-danger my-0 d-block" role="alert">
                                            <p className="mb-3" dangerouslySetInnerHTML={{
                                                __html: restrictModalDetail?.restrictionProductsList?.schoolrestriction?.quarantineMessage ?
                                                    restrictModalDetail.restrictionProductsList.schoolrestriction.quarantineMessage : ''
                                            }}
                                            >
                                            </p>
                                            <div className="text-center text-md-end">
                                                <button className="btn btn-primary" onClick={() => removeRestrictItem('removeSchoolItem')} >Remove Items</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <ul className="list-unstyled remove-restrict-items mb-3">
                                            {productRestrictDetails && productRestrictDetails.map((productList) => {
                                                return (
                                                    <>
                                                        <li className="remove-restrict-item">
                                                            <div className="row">
                                                                <div className="col-10 col-md-2 list-sku">Item # {productList.catalogRefId}</div>
                                                                <div className="col-10 order-3 order-md-2 col-md-8 list-title">{productList.displayName}</div>
                                                                <div className="col-2 order-2 order-md-3 item-qty text-center fw-normal">Qty: {productList.quantity}</div>
                                                            </div>
                                                        </li>
                                                    </>
                                                )
                                            })}

                                        </ul>
                                    </div>
                                </div>
                                : ''}
                        </div>

                    </div>
                </div>
            </div>
        </div >
    )
}

export default ProductRestrictionModal
